import UndoIcon from '@mui/icons-material/Undo';
import { MenuItem } from '@src/common/components/Menu';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { PermitStatus } from '@src/orders/domain/PermitApplication';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permit: PermitSummary;
  order: OrderListing;
}
export const ReopenForCorrection = forwardRef<HTMLLIElement, Props>(
  ({ permit, order, ...menuItemProps }, ref) => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const navigateToReopenedPage = () => {
      const recompletablePermit = [
        PermitStatus.ISSUED,
        PermitStatus.ISSUED_ERROR,
        PermitStatus.DENIED,
      ];
      const reprocessablePermit = [PermitStatus.WITH_JURISDICTION];
      if (recompletablePermit.includes(permit.status)) {
        navigate(OrdersNavigation.completePermit.url(order.id, permit.id), {
          state: {
            allowUpdate: true,
          },
        });
      } else if (reprocessablePermit.includes(permit.status)) {
        navigate(OrdersNavigation.processPermit.url(order.id, permit.id));
      }
    };

    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={() => navigateToReopenedPage()}
        >
          <UndoIcon style={actionIconStyle} />
          {t('permitApplication.reopen')}
        </MenuItem>
      </>
    );
  },
);
